import {
  ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__REQUEST,
  ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS,
  ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__SUCCESS:
    case ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__REQUEST:
      return null;

    case ACTION_DELETE_SITE_FOOTER_LINK_TRANSLATION__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
